module.exports = __webpack_public_path__ + "assets/img/email-91e1da82.png";